module.exports = __webpack_public_path__ + "assets/612e5aff22e9166ee6383c944e0d6b0e.jpg";